import { luscinia } from "./luscinia";

luscinia.isMachineTestEnvironment = function() {
    return document.getElementById('machine-test-environment') != null;
};